import { render } from "./register_restriction.vue?vue&type=template&id=d061e7ec&scoped=true"
import script from "./register_restriction.vue?vue&type=script&lang=js"
export * from "./register_restriction.vue?vue&type=script&lang=js"

import "./register_restriction.vue?vue&type=style&index=0&id=d061e7ec&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d061e7ec"]])

export default __exports__